/*
 * This file contains screen width breakpoints for the site.
 */

const breakpoints = [ 640 ];
export default breakpoints;
